import { requestConsent } from '../../scripts/consentManager';

const videoJsClass = 'js-video';
const videoButtonJsClass = videoJsClass + '-button';

initializeVideos();

export function initializeVideos () {
    const videoElements = document.querySelectorAll('.' + videoJsClass) as NodeListOf<HTMLElement>;

    videoElements.forEach((videoElement) => {
        const service = videoElement.querySelector('iframe')?.dataset.service;

        if (service) {
            const videoButtonElement = videoElement.querySelector('.' + videoButtonJsClass) as HTMLElement;

            if (!videoButtonElement) {
                console.error('Video button not found.');
                return;
            }

            videoButtonElement.addEventListener('click', () => {
                requestConsent(service);
            });
        }
    });
}